module.exports = __webpack_public_path__ + "static/media/gen-01.728b5bea.png";